import {analyzeStack} from "utils/Helpers";

export const defaultOrder = {
    // logo: '',
    introText: '',
    featured: '',
    'contest':'',
    martellus: '',
    deadmau5: '',
    cache: '',
    brooke: '',
    spotlight: '',
    'project-inspire': '',
    'customize-yours': ''
}

function initLocation(){
    let location = window.location.pathname.replace('/','');
    let newOrder = analyzeStack(location, defaultOrder);
    return newOrder
}

let initialState = {
    fromTo: {},
    stackOrder: initLocation(),
    skipAnimation: false,
    panel: null
};



function PanelsReducer(state = initialState, action){


    switch (action.type) {
        case "SET_PANEL_DATA":
            return action.payload;

        default: return state;
    }
}

export default PanelsReducer;
